// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'  
import Vue from 'vue'
import App from './App'
import router from './router'

//SET IDIOMA
localStorage.setItem('language', 'es');

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
let token = window.localStorage.getItem('_token');
let id = window.localStorage.getItem('_id');
if(!!token){
	axios.defaults.headers.common['token'] = token;
	axios.defaults.headers.common['id'] = id;
}
//.AXIOS

//VEE-VALIDATE
import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE


//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: store.state.language, 
  messages,
});
//.IDIOMAS


// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';

// Sentry.init({
//   dsn: 'https://4f2558b9d92e4bccb9673afd378a4db5@o393426.ingest.sentry.io/5250057',
//   integrations: [new VueIntegration({Vue, attachProps: true, logErrors : true})],
// });


Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
  VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js